import PrivacyIndex from "../PrivacyIndex";
import GradientBackground from "./GradientBackground";
import s from '../../styles/home.module.css'
import TermIndex from "../TermIndex";
import AccountRemoveIndex from "../AccountRemoveIndex";

export default function Home() {
  return (
    <>
      <GradientBackground />

      <div className={s.homeMainBox}>
          <div className={s.box_soon}>
            <h2 className={s.soonTitle}>This site is under development.</h2>
            <h3 className={s.soonSubTitle}>In the meantime, you can browse the pages listed below.</h3>
          </div>
          <h1>Site map</h1>
          <div className={s.sitemap_box}>
              <PrivacyIndex />
              <TermIndex />
              <AccountRemoveIndex />
          </div>
          
      </div>
    </>
  );
}
